import { forwardRef } from "react";
import { regex, useInput } from "react-admin";

import { TagsField } from "./TagsField";

interface Props {
  source: string;
  label?: string;
  placeholder?: string;
  value: string[];
  onChange: (value: string[]) => void;
}

export const TagsFieldWrapperControlled = forwardRef(
  ({ source, value, onChange, ...props }: Props, ref) => {
    const { field } = useInput({
      source,
      defaultValue: [],
      validate: [regex(/^[a-zA-Z0-9.]*$/, "Tags can only contain letters, numbers, and periods")]
    });

    const handleChange = (nextValue: string[]) => {
      field.onChange(nextValue);
      onChange(nextValue);
    };

    return (
      <TagsField
        name={field.name}
        onBlur={field.onBlur}
        {...props}
        ref={ref}
        value={value}
        onChange={handleChange}
        helperText="Separate labels with ENTER"
      />
    );
  }
);
